import { render, staticRenderFns } from "./StatisticsTradeTurnoverP2P.vue?vue&type=template&id=e88c2fb2&"
import script from "./StatisticsTradeTurnoverP2P.vue?vue&type=script&lang=js&"
export * from "./StatisticsTradeTurnoverP2P.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTradeTurnoverP2P.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports